import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import { compose } from 'utils/compose';
import { inject, observer } from 'mobx-react';
import { useParams, useNavigate } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent, Typography } from '@mui/material';

import { DialogActionButton, DialogFooter } from '.';

const PREFIX = 'ExitSession';

const classes = {
  container: `${PREFIX}-container`,
  dialogPaper: `${PREFIX}-dialogPaper`,
  dialogTitle: `${PREFIX}-dialogTitle`,
  darkGrayText: `${PREFIX}-darkGrayText`,
  dialogBodyText: `${PREFIX}-dialogBodyText`,
};

const StyledDialog = styled(Dialog)(({ theme }) => ({
  [`& .${classes.container}`]: {
    color: theme.colorTokens.onSurfaceTextTitle,
  },

  [`& .${classes.dialogPaper}`]: {
    overflowScrolling: 'touch',
    WebkitOverflowScrolling: 'touch',
  },

  [`& .${classes.dialogTitle}`]: {
    fontWeight: 700,
    color: theme.colorTokens.onSurfaceTextHeadline,
    textAlign: 'left',
    fontSize: '1.2rem',
    paddingTop: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },

  [`& .${classes.darkGrayText}`]: {
    color: theme.colorTokens.onSurfaceTextTitle,
  },

  [`& .${classes.dialogBodyText}`]: {
    textAlign: 'left',
  },
}));

const ExitSession = compose(
  inject('store'),
  observer,
)(({ store }) => {
  const { trackingCode } = useParams();
  const navigate = useNavigate();
  const { deliveryStore } = store;
  const { exitSessionDialog, tokenRemainingTime } = deliveryStore;

  const handleExitSession = () => {
    deliveryStore.exitSession(() => navigate(`/${trackingCode}`));
  };

  return (
    <StyledDialog
      open={exitSessionDialog || !tokenRemainingTime}
      onClose={() => deliveryStore.closeExitSessionDialog()}
      PaperProps={{ style: { padding: '24px 0', textAlign: 'center' }, className: clsx(classes.container, classes.dialogPaper) }}
      disableEscapeKeyDown={!tokenRemainingTime}
      maxWidth="sm"
    >
      <DialogTitle className={classes.dialogTitle}>
        {!tokenRemainingTime ? 'Your token has expired!' : 'Manage Delivery Exit Confirmation'}
      </DialogTitle>
      <DialogContent>
        <Typography className={clsx(classes.darkGrayText, classes.dialogBodyText)}>
          You will need to go through verification again to start another Manage Delivery session.
          {!!tokenRemainingTime && ' Please confirm if you want to exit this current session!'}
        </Typography>
      </DialogContent>
      <DialogFooter style={{ justifyContent: tokenRemainingTime ? 'space-between' : 'flex-end' }}>
        {!!tokenRemainingTime && (
          <DialogActionButton onClick={() => deliveryStore.closeExitSessionDialog()} variant="outlined" color="primary" disableElevation>
            CANCEL
          </DialogActionButton>
        )}
        <DialogActionButton onClick={handleExitSession} variant="contained" color="primary" disableElevation>
          EXIT
        </DialogActionButton>
      </DialogFooter>
    </StyledDialog>
  );
});

export default ExitSession;
